/**
 * HomeARDemoPeopleContentView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeARDemoPeopleContent
 */

import { useHomeARDemoPeopleContentLogic } from '@/hooks/traits/useHomeARDemoPeopleContentLogic';
import type { HomeARDemoPeopleContentConfig } from '@/hooks/traits/useHomeARDemoPeopleContentLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeARDemoPeopleLeave } from '@app/shared';
import { Split } from '@almadar/ui/components';
import { Card } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { Typography } from '@almadar/ui/components';
import { HomeARDemoPeopleStatsView } from '@/components/traits/HomeARDemoPeopleStatsView';
import { HomeARDemoPeopleCalendarView } from '@/components/traits/HomeARDemoPeopleCalendarView';
import { HomeARDemoPeopleTypeChartView } from '@/components/traits/HomeARDemoPeopleTypeChartView';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface HomeARDemoPeopleContentViewProps {
  config?: Partial<HomeARDemoPeopleContentConfig>;
}

export function HomeARDemoPeopleContentView({ config: propsConfig }: HomeARDemoPeopleContentViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeARDemoPeopleContentLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeARDemoPeopleLeave'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeAR" trait="HomeARDemoPeopleContent">
      {slotWriter['main'] === 'INIT' ? (<Stack gap="md" direction="vertical" className="p-5"><Stack gap="none" direction="vertical"><Typography content={renderPatternValue(__t("std-almadar-demo-people-page:page.title"))} variant="h3" /><Typography color="muted" content={renderPatternValue(__t("std-almadar-demo-people-page:page.subtitle"))} variant="small" /></Stack><Split ratio="3:1" gap="md"><Card padding="sm"><HomeARDemoPeopleCalendarView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Card><Stack direction="vertical" gap="md"><HomeARDemoPeopleStatsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Card padding="sm"><HomeARDemoPeopleTypeChartView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Card></Stack></Split></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default HomeARDemoPeopleContentView;
